// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__x17m7","load":"skeleton_load__z1tru"};